export default __webpack_public_path__ + "4001890f8ed6222217cb2bc2faf93aaf.png";